// import React, { useState, useEffect, useRef, useCallback } from 'react';
// import { useLocation } from 'react-router-dom';
// import { toast } from 'react-toastify';
// import { format, parseISO } from 'date-fns';
// import * as Yup from 'yup';
// import * as XLSX from 'xlsx';
// import { saveAs } from 'file-saver';

// import { MdOutlineFileDownload } from 'react-icons/md';

// import { useSelector } from 'react-redux';
// import api from '../../../../services/api';
// import history from '../../../../services/history';

// import { AppError } from '../../../../errors/AppError';

// import { getMaterialFabricante } from '../../../../lib/asyncUtils';

// import TitleBar from '../../../../components/TitleBar';
// import { FormWrapper, Form } from '../../../../components/Form';
// import Input from '../../../../components/Form/Input';
// import AsyncSelect from '../../../../components/Form/Input/AsyncSelect';
// import {
//   BoxInfoHeader,
//   BoxInfoLineList,
//   ButtonAction,
//   CardEmptyList,
//   ContainerCatalogoAndButton,
//   ContainerLineList,
//   ContainerList,
//   ContainerSpanAndButton,
//   EmptyList,
//   HeaderContainerList,
//   InfoRow,
//   LeftContainer,
//   LeftWrapper,
//   MasterWrapper,
//   PageInfo,
//   RightContainer,
//   RightTitleContainer,
//   RightWrapper,
//   Span,
//   Title,
//   TitleModeloAndCatalogo,
//   UpdateInfo,
//   UpdateItem,
//   UpdateList,
//   WrapperButtonsAction,
//   WrapperLineList,
//   WrapperList,
// } from './styles';
// import { opAlteracaoPartnumber } from '../../../../lib/inputOption';

// /** validação dos campos */
// const schema = Yup.object().shape(
//   {
//     partnumber: Yup.string().required(
//       'O campo "Partnumber" deve ser preenchido'
//     ),
//     ncm: Yup.string(),
//     descricaoBR: Yup.string().when('descricaoEN', {
//       is: (descricaoEN) => !descricaoEN,
//       then: Yup.string().required(
//         'É necessário preencher ao menos um dos campos "Descrição"'
//       ),
//     }),
//     descricaoEN: Yup.string().when('descricaoBR', {
//       is: (descricaoBR) => !descricaoBR,
//       then: Yup.string().required(
//         'É necessário preencher ao menos um dos campos "Descrição"'
//       ),
//     }),
//     descricaoIT: Yup.string(),
//     descricaoFR: Yup.string(),
//     descricaoRU: Yup.string(),
//     descricaoDE: Yup.string(),
//     descricaoES: Yup.string(),
//   },
//   ['descricaoBR', 'descricaoEN']
// );

// function MaterialFabricanteEditar() {
//   const formRef = useRef(null);

//   const location = useLocation();

//   const selectUser = useSelector((state) => state.user);

//   const { idEmpresa } = selectUser.profile.empresa;

//   const { id, idFabricante } = location.state;

//   // const { userId, name = '', adm, empresa } = state.user.profile || {};
//   // const { idEmpresa, url: logotipo } = empresa || {};

//   const [materialFabricante, setMaterialFabricante] = useState(null);
//   const [paginaCatalogo, setPaginaCatalogo] = useState([]);

//   const [updatePN, setUpdatePN] = useState([]);

//   useEffect(() => {
//     api.get(`material-fabricante/${id}`).then((response) => {
//       const {
//         dataDesa,
//         materialOrigem,
//         catalogos = [],
//         ...rst
//       } = response.data;

//       setMaterialFabricante({
//         ...rst,
//         dataDesa: dataDesa ? format(parseISO(dataDesa), 'dd/MM/yyyy') : null,
//       });

//       setPaginaCatalogo(catalogos);

//       /** preenchimento do campo material fabricante origem */
//       if (materialOrigem) {
//         formRef.current.setFieldValue('idMaterialOri', {
//           value: materialOrigem.idMaterial,
//           label: `${materialOrigem.partnumber} | ${materialOrigem.descricaoBR} (${materialOrigem.descricaoEN})`,
//         });
//       }
//     });
//   }, [id]);

//   const loadUpdatePN = useCallback(async () => {
//     console.log({ idEmpresa, id });
//     const response = await api.get(`empresa/${idEmpresa}/${id}/update-pn`);

//     setUpdatePN(
//       response.data.updatePN.map((item) => ({
//         ...item,
//         instinc: format(parseISO(item.instinc), "dd/MM/yyyy 'às' HH:mm:ss"),
//       }))
//     );
//   }, [idEmpresa, id]);

//   useEffect(() => {
//     loadUpdatePN();
//   }, [loadUpdatePN]);

//   const handleConfirmar = useCallback(
//     async (data) => {
//       try {
//         await schema.validate(data, {
//           abortEarly: false,
//         });

//         // const {
//         //   partnumber,
//         //   ncm,
//         //   descricaoBR,
//         //   descricaoEN,
//         //   idMaterialOri,
//         // } = data;

//         const {
//           partnumber,
//           ncm,
//           descricaoBR,
//           descricaoEN,
//           descricaoIT,
//           descricaoFR,
//           descricaoRU,
//           descricaoDE,
//           descricaoES,
//           idMaterialOri,
//         } = data;

//         // await api.put(`/material-fabricante/${id}`, {
//         //   partnumber,
//         //   ncm,
//         //   descricaoBR,
//         //   descricaoEN,
//         //   idMaterialOri: Number(idMaterialOri) || null,
//         //   idFabricante,
//         // });

//         await api.post(`/material-fabricante/${id}`, {
//           partnumber,
//           ncm,
//           descricaoBR,
//           descricaoEN,
//           descricaoIT,
//           descricaoFR,
//           descricaoRU,
//           descricaoDE,
//           descricaoES,
//           idMaterialOri: Number(idMaterialOri) || null,
//           idFabricante,
//         });

//         toast.success('Material Fabricante atualizado com sucesso!');

//         history.goBack();
//       } catch (err) {
//         AppError(err, formRef);
//       }
//     },
//     [id, idFabricante]
//   );

//   const handleExportarCatalogos = useCallback(() => {
//     try {
//       if (!paginaCatalogo.length) {
//         toast.warning('Não há catálogos para exportar.');
//         return;
//       }

//       const dadosExportacao = [];

//       paginaCatalogo.forEach((catalogo) => {
//         if (catalogo.paginaCatalogo?.length > 0) {
//           catalogo.paginaCatalogo.forEach((pagina) => {
//             dadosExportacao.push({
//               'ID Catálogo': catalogo.idCatalogo,
//               'Nome Catálogo': catalogo.nome || 'Catálogo sem nome',
//               Modelo: catalogo.modelos[0].descricao,
//               'Qtd. Páginas Vinculadas': catalogo.paginaCatalogo?.length || 0,
//               'ID Página': pagina.idPagina,
//               'ID Item': pagina.itemPagina[0].idItem,
//               'Descrição Página/Item': pagina.descricao || '-',
//               Partnumber: materialFabricante?.partnumber || '',
//               NCM: materialFabricante?.ncm || '',
//               'Descrição BR Material': materialFabricante?.descricaoBR || '',
//               'Descrição EN Material': materialFabricante?.descricaoEN || '',
//             });
//           });
//         } else {
//           dadosExportacao.push({
//             'ID Catálogo': catalogo.idCatalogo,
//             'Nome Catálogo': catalogo.nome || 'Catálogo sem nome',
//             Modelo: catalogo.modelos[0].descricao,
//             'Qtd. Páginas Vinculadas': 0,
//             'ID Página': '',
//             'ID Item': '',
//             'Descrição Página/Item':
//               'Este catálogo não possui páginas vinculadas.',
//             Partnumber: materialFabricante?.partnumber || '',
//             NCM: materialFabricante?.ncm || '',
//             'Descrição BR Material': materialFabricante?.descricaoBR || '',
//             'Descrição EN Material': materialFabricante?.descricaoEN || '',
//           });
//         }
//       });

//       const worksheet = XLSX.utils.json_to_sheet(dadosExportacao);

//       const colunas = [
//         { wch: 14 },
//         { wch: 35 },
//         { wch: 22 },
//         { wch: 22 },
//         { wch: 12 },
//         { wch: 12 },
//         { wch: 45 },
//         { wch: 20 },
//         { wch: 20 },
//         { wch: 35 },
//         { wch: 35 },
//       ];

//       worksheet['!cols'] = colunas;

//       const workbook = XLSX.utils.book_new();
//       XLSX.utils.book_append_sheet(workbook, worksheet, 'Catálogos');

//       const excelBuffer = XLSX.write(workbook, {
//         bookType: 'xlsx',
//         type: 'array',
//       });

//       const arquivo = new Blob([excelBuffer], {
//         type:
//           'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8',
//       });

//       const nomeArquivo = `catalogos_partnumber_${
//         materialFabricante?.partnumber || id
//       }.xlsx`;

//       saveAs(arquivo, nomeArquivo);

//       toast.success('Arquivo Excel exportado com sucesso!');
//     } catch (error) {
//       toast.error('Erro ao exportar os catálogos para Excel.');
//     }
//   }, [paginaCatalogo, materialFabricante, id]);

//   const handleActionButton = useCallback(
//     async (status, partnumber) => {
//       try {
//         await api.put(`empresa/${idEmpresa}/update-pn/status`, {
//           idMaterial: Number(id),
//           partnumber: String(partnumber),
//           status: Number(status),
//         });

//         toast.success('Status atualizado com sucesso!');

//         await loadUpdatePN();
//       } catch (error) {
//         AppError(error);
//       }
//     },
//     [idEmpresa, id, loadUpdatePN]
//   );

//   return (
//     <>
//       <TitleBar
//         back={!!location.background}
//         title="Alterar Material Fabricante"
//       />

//       <FormWrapper>
//         <Form
//           id="form-ref"
//           ref={formRef}
//           schema={schema}
//           initialData={materialFabricante}
//           onSubmit={handleConfirmar}
//           autoComplete="off"
//         >
//           <MasterWrapper>
//             {/* LADO ESQUERDO - FORMULÁRIO */}
//             <LeftWrapper>
//               <LeftContainer>
//                 <Title>Dados do Material Fabricante</Title>
//                 <Span>Atualize as informações do registro</Span>
//               </LeftContainer>

//               <Form.Column>
//                 <Form.Row>
//                   <Input id="partnumber" name="partnumber" label="Partnumber" />
//                   <Input id="ncm" name="ncm" label="NCM" />
//                   <Input
//                     id="dataDesa"
//                     name="dataDesa"
//                     label="Data de Desativação"
//                     disabled
//                   />
//                 </Form.Row>

//                 <Form.Row>
//                   <Input
//                     id="descricaoBR"
//                     name="descricaoBR"
//                     label="Descrição (BR)"
//                   />
//                   <Input
//                     id="descricaoEN"
//                     name="descricaoEN"
//                     label="Descrição (EN)"
//                   />
//                 </Form.Row>
//                 {/* <Form.Row>
//                   <Input
//                     id="descricaoIT"
//                     name="descricaoIT"
//                     label="Descrição IT"
//                   />
//                   <Input
//                     id="descricaoFR"
//                     name="descricaoFR"
//                     label="Descrição FR"
//                   />
//                 </Form.Row>
//                 <Form.Row>
//                   <Input
//                     id="descricaoRU"
//                     name="descricaoRU"
//                     label="Descrição RU"
//                   />
//                   <Input
//                     id="descricaoDE"
//                     name="descricaoDE"
//                     label="Descrição DE"
//                   />
//                 </Form.Row>
//                 <Form.Row>
//                   <Input
//                     id="descricaoES"
//                     name="descricaoES"
//                     label="Descrição ES"
//                   />
//                 </Form.Row> */}

//                 <Form.Row>
//                   <AsyncSelect
//                     id="idMaterialOri"
//                     name="idMaterialOri"
//                     label="Material Origem"
//                     isClearable
//                     cacheOptions
//                     defaultOptions
//                     loadOptions={(value, cb) =>
//                       getMaterialFabricante({ id: idFabricante, value }, cb)
//                     }
//                     menuPosition="fixed"
//                   />
//                 </Form.Row>
//               </Form.Column>

//               <Form.Separate withFlex />

//               <Form.Footer>
//                 <button
//                   id="btn-cancel"
//                   type="button"
//                   onClick={() => history.goBack()}
//                 >
//                   Cancelar
//                 </button>
//                 <button id="btn-submit" type="submit" form="form-ref">
//                   Confirmar
//                 </button>
//               </Form.Footer>

//               {/* Lista de atualizações de partnumber */}
//               <UpdateList>
//                 <Span>Atualizações do Partnumber</Span>

//                 {updatePN?.length > 0 ? (
//                   updatePN.map((updt) => {
//                     const status = updt.updatePNEmpresa?.[0]?.status;

//                     return (
//                       <UpdateItem
//                         key={`${updt.id}-${updt.idMaterial}`}
//                         $status={status}
//                       >
//                         <UpdateInfo>
//                           <InfoRow>
//                             <strong>Partnumber:</strong>
//                             <span>{updt.partnumber}</span>
//                           </InfoRow>

//                           <InfoRow>
//                             <strong>Data Alteração:</strong>
//                             <span>{updt.instinc}</span>
//                           </InfoRow>

//                           <InfoRow>
//                             <strong>Status:</strong>
//                             <span>
//                               {opAlteracaoPartnumber?.[status]?.label || '-'}
//                             </span>
//                           </InfoRow>
//                         </UpdateInfo>

//                         {status === 0 && (
//                           <WrapperButtonsAction>
//                             <ButtonAction
//                               type="button"
//                               onClick={() =>
//                                 handleActionButton(2, updt.partnumber)
//                               }
//                             >
//                               Recusar
//                             </ButtonAction>
//                             <ButtonAction
//                               type="button"
//                               onClick={() =>
//                                 handleActionButton(1, updt.partnumber)
//                               }
//                               $isAprove
//                             >
//                               Aprovar
//                             </ButtonAction>
//                           </WrapperButtonsAction>
//                         )}
//                       </UpdateItem>
//                     );
//                   })
//                 ) : (
//                   <EmptyList>
//                     Este partnumber não possui atualizações.
//                   </EmptyList>
//                 )}
//               </UpdateList>
//             </LeftWrapper>

//             {/* LADO DIREITO - LISTAGEM */}
//             <RightWrapper>
//               <RightContainer>
//                 <RightTitleContainer>
//                   <div>
//                     <Title>Lista de Catálogos do Partnumber</Title>
//                     <Span>Catálogos vinculados a este material fabricante</Span>
//                   </div>

//                   <ContainerSpanAndButton $hasCatalogo={paginaCatalogo.length}>
//                     <span>{paginaCatalogo.length}</span>

//                     <button
//                       type="button"
//                       onClick={handleExportarCatalogos}
//                       disabled={!paginaCatalogo.length}
//                       title="Exportar listagem para Excel"
//                     >
//                       <MdOutlineFileDownload size={20} />
//                     </button>
//                   </ContainerSpanAndButton>
//                 </RightTitleContainer>

//                 {paginaCatalogo.length > 0 ? (
//                   <WrapperList>
//                     {paginaCatalogo.map((catalogo) => (
//                       <ContainerList key={catalogo.idCatalogo}>
//                         <HeaderContainerList>
//                           <div>
//                             <TitleModeloAndCatalogo>
//                               {catalogo.modelos[0].descricao} /{' '}
//                               {catalogo.nome || 'Catálogo sem nome'}
//                             </TitleModeloAndCatalogo>

//                             <PageInfo>
//                               {catalogo.paginaCatalogo?.length || 0} página(s)
//                               vinculada(s)
//                             </PageInfo>
//                           </div>

//                           <ContainerCatalogoAndButton>
//                             <span>ID Catálogo: {catalogo.idCatalogo}</span>

//                             <button
//                               type="button"
//                               onClick={() =>
//                                 history.push('/catalogo/detalhe', {
//                                   id: catalogo.idCatalogo,
//                                 })
//                               }
//                               title={`Ver detalhes do catálogo ${catalogo.idCatalogo}`}
//                             >
//                               Ver catálogo
//                             </button>
//                           </ContainerCatalogoAndButton>
//                         </HeaderContainerList>

//                         <WrapperLineList>
//                           <ContainerLineList>
//                             <BoxInfoHeader $minWidth120>Página</BoxInfoHeader>
//                             <BoxInfoHeader $minWidth120>Item</BoxInfoHeader>
//                             <BoxInfoHeader>Sistema</BoxInfoHeader>
//                           </ContainerLineList>
//                           {catalogo.paginaCatalogo?.length > 0 ? (
//                             catalogo.paginaCatalogo.map((pagina) => (
//                               <ContainerLineList
//                                 key={`${catalogo.idCatalogo}-${pagina.idPagina}-${pagina.itemPagina[0].idItem}`}
//                               >
//                                 <BoxInfoLineList $minWidth120 $center>
//                                   {pagina.idPagina}
//                                 </BoxInfoLineList>

//                                 <BoxInfoLineList $minWidth120 $center>
//                                   {pagina.itemPagina[0].idItem}
//                                 </BoxInfoLineList>

//                                 <BoxInfoLineList>
//                                   {pagina.descricao || '-'}
//                                 </BoxInfoLineList>
//                               </ContainerLineList>
//                             ))
//                           ) : (
//                             <CardEmptyList>
//                               Este catálogo não possui páginas vinculadas.
//                             </CardEmptyList>
//                           )}
//                         </WrapperLineList>
//                       </ContainerList>
//                     ))}
//                   </WrapperList>
//                 ) : (
//                   <CardEmptyList>
//                     Nenhum catálogo vinculado a este partnumber.
//                   </CardEmptyList>
//                 )}
//               </RightContainer>
//             </RightWrapper>
//           </MasterWrapper>
//         </Form>
//       </FormWrapper>
//     </>
//   );
// }

// export { MaterialFabricanteEditar };

import React, { useState, useEffect, useRef, useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import { format, parseISO } from 'date-fns';
import * as Yup from 'yup';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

import { MdOutlineFileDownload } from 'react-icons/md';

import { useSelector } from 'react-redux';
import api from '../../../../services/api';
import history from '../../../../services/history';

import { AppError } from '../../../../errors/AppError';

import { getMaterialFabricante } from '../../../../lib/asyncUtils';

import TitleBar from '../../../../components/TitleBar';
import { FormWrapper, Form } from '../../../../components/Form';
import Input from '../../../../components/Form/Input';
import AsyncSelect from '../../../../components/Form/Input/AsyncSelect';
import {
  BoxInfoHeader,
  BoxInfoLineList,
  ButtonAction,
  CardEmptyList,
  ContainerCatalogoAndButton,
  ContainerLineList,
  ContainerList,
  ContainerSpanAndButton,
  EmptyList,
  HeaderContainerList,
  ImagemPreviewText,
  ImagemUploadButton,
  ImagemUploadRow,
  ImagemUploadWrapper,
  InfoRow,
  LeftContainer,
  LeftWrapper,
  MasterWrapper,
  PageInfo,
  RightContainer,
  RightTitleContainer,
  RightWrapper,
  Span,
  Title,
  TitleModeloAndCatalogo,
  UpdateInfo,
  UpdateItem,
  UpdateList,
  WrapperButtonsAction,
  WrapperLineList,
  WrapperList,
} from './styles';
import { opAlteracaoPartnumber } from '../../../../lib/inputOption';

/** validação dos campos */
const schema = Yup.object().shape(
  {
    partnumber: Yup.string().required(
      'O campo "Partnumber" deve ser preenchido'
    ),
    ncm: Yup.string(),
    descricaoBR: Yup.string().when('descricaoEN', {
      is: (descricaoEN) => !descricaoEN,
      then: Yup.string().required(
        'É necessário preencher ao menos um dos campos "Descrição"'
      ),
    }),
    descricaoEN: Yup.string().when('descricaoBR', {
      is: (descricaoBR) => !descricaoBR,
      then: Yup.string().required(
        'É necessário preencher ao menos um dos campos "Descrição"'
      ),
    }),
    descricaoIT: Yup.string(),
    descricaoFR: Yup.string(),
    descricaoRU: Yup.string(),
    descricaoDE: Yup.string(),
    descricaoES: Yup.string(),
  },
  ['descricaoBR', 'descricaoEN']
);

function MaterialFabricanteEditar() {
  const formRef = useRef(null);

  const location = useLocation();

  const selectUser = useSelector((state) => state.user);

  const { idEmpresa } = selectUser.profile.empresa;

  const { id, idFabricante } = location.state;

  // const { userId, name = '', adm, empresa } = state.user.profile || {};
  // const { idEmpresa, url: logotipo } = empresa || {};

  const [materialFabricante, setMaterialFabricante] = useState(null);
  const [paginaCatalogo, setPaginaCatalogo] = useState([]);

  const [updatePN, setUpdatePN] = useState([]);

  const [idCatalogoImagem, setIdCatalogoImagem] = useState('');
  const [extensaoImagem, setExtensaoImagem] = useState('jpeg');
  const [arquivoImagem, setArquivoImagem] = useState(null);
  const [enviandoImagem, setEnviandoImagem] = useState(false);

  useEffect(() => {
    api.get(`material-fabricante/${id}`).then((response) => {
      const {
        dataDesa,
        materialOrigem,
        catalogos = [],
        ...rst
      } = response.data;

      setMaterialFabricante({
        ...rst,
        dataDesa: dataDesa ? format(parseISO(dataDesa), 'dd/MM/yyyy') : null,
      });

      setPaginaCatalogo(catalogos);

      /** preenchimento do campo material fabricante origem */
      if (materialOrigem) {
        formRef.current.setFieldValue('idMaterialOri', {
          value: materialOrigem.idMaterial,
          label: `${materialOrigem.partnumber} | ${materialOrigem.descricaoBR} (${materialOrigem.descricaoEN})`,
        });
      }
    });
  }, [id]);

  const loadUpdatePN = useCallback(async () => {
    console.log({ idEmpresa, id });
    const response = await api.get(`empresa/${idEmpresa}/${id}/update-pn`);

    setUpdatePN(
      response.data.updatePN.map((item) => ({
        ...item,
        instinc: format(parseISO(item.instinc), "dd/MM/yyyy 'às' HH:mm:ss"),
      }))
    );
  }, [idEmpresa, id]);

  useEffect(() => {
    loadUpdatePN();
  }, [loadUpdatePN]);

  const handleConfirmar = useCallback(
    async (data) => {
      try {
        await schema.validate(data, {
          abortEarly: false,
        });

        // const {
        //   partnumber,
        //   ncm,
        //   descricaoBR,
        //   descricaoEN,
        //   idMaterialOri,
        // } = data;

        const {
          partnumber,
          ncm,
          descricaoBR,
          descricaoEN,
          descricaoIT,
          descricaoFR,
          descricaoRU,
          descricaoDE,
          descricaoES,
          idMaterialOri,
        } = data;

        // await api.put(`/material-fabricante/${id}`, {
        //   partnumber,
        //   ncm,
        //   descricaoBR,
        //   descricaoEN,
        //   idMaterialOri: Number(idMaterialOri) || null,
        //   idFabricante,
        // });

        await api.post(`/material-fabricante/${id}`, {
          partnumber,
          ncm,
          descricaoBR,
          descricaoEN,
          descricaoIT,
          descricaoFR,
          descricaoRU,
          descricaoDE,
          descricaoES,
          idMaterialOri: Number(idMaterialOri) || null,
          idFabricante,
        });

        toast.success('Material Fabricante atualizado com sucesso!');

        history.goBack();
      } catch (err) {
        AppError(err, formRef);
      }
    },
    [id, idFabricante]
  );

  const handleExportarCatalogos = useCallback(() => {
    try {
      if (!paginaCatalogo.length) {
        toast.warning('Não há catálogos para exportar.');
        return;
      }

      const dadosExportacao = [];

      paginaCatalogo.forEach((catalogo) => {
        if (catalogo.paginaCatalogo?.length > 0) {
          catalogo.paginaCatalogo.forEach((pagina) => {
            dadosExportacao.push({
              'ID Catálogo': catalogo.idCatalogo,
              'Nome Catálogo': catalogo.nome || 'Catálogo sem nome',
              Modelo: catalogo.modelos[0].descricao,
              'Qtd. Páginas Vinculadas': catalogo.paginaCatalogo?.length || 0,
              'ID Página': pagina.idPagina,
              'ID Item': pagina.itemPagina[0].idItem,
              'Descrição Página/Item': pagina.descricao || '-',
              Partnumber: materialFabricante?.partnumber || '',
              NCM: materialFabricante?.ncm || '',
              'Descrição BR Material': materialFabricante?.descricaoBR || '',
              'Descrição EN Material': materialFabricante?.descricaoEN || '',
            });
          });
        } else {
          dadosExportacao.push({
            'ID Catálogo': catalogo.idCatalogo,
            'Nome Catálogo': catalogo.nome || 'Catálogo sem nome',
            Modelo: catalogo.modelos[0].descricao,
            'Qtd. Páginas Vinculadas': 0,
            'ID Página': '',
            'ID Item': '',
            'Descrição Página/Item':
              'Este catálogo não possui páginas vinculadas.',
            Partnumber: materialFabricante?.partnumber || '',
            NCM: materialFabricante?.ncm || '',
            'Descrição BR Material': materialFabricante?.descricaoBR || '',
            'Descrição EN Material': materialFabricante?.descricaoEN || '',
          });
        }
      });

      const worksheet = XLSX.utils.json_to_sheet(dadosExportacao);

      const colunas = [
        { wch: 14 },
        { wch: 35 },
        { wch: 22 },
        { wch: 22 },
        { wch: 12 },
        { wch: 12 },
        { wch: 45 },
        { wch: 20 },
        { wch: 20 },
        { wch: 35 },
        { wch: 35 },
      ];

      worksheet['!cols'] = colunas;

      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Catálogos');

      const excelBuffer = XLSX.write(workbook, {
        bookType: 'xlsx',
        type: 'array',
      });

      const arquivo = new Blob([excelBuffer], {
        type:
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8',
      });

      const nomeArquivo = `catalogos_partnumber_${
        materialFabricante?.partnumber || id
      }.xlsx`;

      saveAs(arquivo, nomeArquivo);

      toast.success('Arquivo Excel exportado com sucesso!');
    } catch (error) {
      toast.error('Erro ao exportar os catálogos para Excel.');
    }
  }, [paginaCatalogo, materialFabricante, id]);

  const handleActionButton = useCallback(
    async (status, partnumber) => {
      try {
        await api.put(`empresa/${idEmpresa}/update-pn/status`, {
          idMaterial: Number(id),
          partnumber: String(partnumber),
          status: Number(status),
        });

        toast.success('Status atualizado com sucesso!');

        await loadUpdatePN();
      } catch (error) {
        AppError(error);
      }
    },
    [idEmpresa, id, loadUpdatePN]
  );

  const handleSelecionarArquivoImagem = useCallback((event) => {
    const [file] = event.target.files || [];
    setArquivoImagem(file || null);
  }, []);

  const handleEnviarImagem = useCallback(async () => {
    try {
      if (!idCatalogoImagem) {
        toast.warning('Selecione o catálogo para vincular a imagem.');
        return;
      }

      if (!arquivoImagem) {
        toast.warning('Selecione o arquivo de imagem.');
        return;
      }

      setEnviandoImagem(true);

      const formData = new FormData();
      formData.append('file', arquivoImagem);
      formData.append('idCatalogo', idCatalogoImagem);
      formData.append('extensao', extensaoImagem);

      const { data } = await api.put(
        `material-fabricante/${id}/imagem`,
        formData
      );

      toast.success(`Imagem enviada com sucesso: ${data.blobName}`);

      setArquivoImagem(null);
    } catch (err) {
      AppError(err, formRef);
    } finally {
      setEnviandoImagem(false);
    }
  }, [id, idCatalogoImagem, extensaoImagem, arquivoImagem]);

  return (
    <>
      <TitleBar
        back={!!location.background}
        title="Alterar Material Fabricante"
      />

      <FormWrapper>
        <Form
          id="form-ref"
          ref={formRef}
          schema={schema}
          initialData={materialFabricante}
          onSubmit={handleConfirmar}
          autoComplete="off"
        >
          <MasterWrapper>
            {/* LADO ESQUERDO - FORMULÁRIO */}
            <LeftWrapper>
              <LeftContainer>
                <Title>Dados do Material Fabricante</Title>
                <Span>Atualize as informações do registro</Span>
              </LeftContainer>

              <Form.Column>
                <Form.Row>
                  <Input id="partnumber" name="partnumber" label="Partnumber" />
                  <Input id="ncm" name="ncm" label="NCM" />
                  <Input
                    id="dataDesa"
                    name="dataDesa"
                    label="Data de Desativação"
                    disabled
                  />
                </Form.Row>

                <Form.Row>
                  <Input
                    id="descricaoBR"
                    name="descricaoBR"
                    label="Descrição (BR)"
                  />
                  <Input
                    id="descricaoEN"
                    name="descricaoEN"
                    label="Descrição (EN)"
                  />
                </Form.Row>
                {/* <Form.Row>
                  <Input
                    id="descricaoIT"
                    name="descricaoIT"
                    label="Descrição IT"
                  />
                  <Input
                    id="descricaoFR"
                    name="descricaoFR"
                    label="Descrição FR"
                  />
                </Form.Row>
                <Form.Row>
                  <Input
                    id="descricaoRU"
                    name="descricaoRU"
                    label="Descrição RU"
                  />
                  <Input
                    id="descricaoDE"
                    name="descricaoDE"
                    label="Descrição DE"
                  />
                </Form.Row>
                <Form.Row>
                  <Input
                    id="descricaoES"
                    name="descricaoES"
                    label="Descrição ES"
                  />
                </Form.Row> */}

                <Form.Row>
                  <AsyncSelect
                    id="idMaterialOri"
                    name="idMaterialOri"
                    label="Material Origem"
                    isClearable
                    cacheOptions
                    defaultOptions
                    loadOptions={(value, cb) =>
                      getMaterialFabricante({ id: idFabricante, value }, cb)
                    }
                    menuPosition="fixed"
                  />
                </Form.Row>
              </Form.Column>

              <Form.Separate withFlex />

              <Form.Footer>
                <button
                  id="btn-cancel"
                  type="button"
                  onClick={() => history.goBack()}
                >
                  Cancelar
                </button>
                <button id="btn-submit" type="submit" form="form-ref">
                  Confirmar
                </button>
              </Form.Footer>

              {/* Lista de atualizações de partnumber */}
              <UpdateList>
                <Span>Atualizações do Partnumber</Span>

                {updatePN?.length > 0 ? (
                  updatePN.map((updt) => {
                    const status = updt.updatePNEmpresa?.[0]?.status;

                    return (
                      <UpdateItem
                        key={`${updt.id}-${updt.idMaterial}`}
                        $status={status}
                      >
                        <UpdateInfo>
                          <InfoRow>
                            <strong>Partnumber:</strong>
                            <span>{updt.partnumber}</span>
                          </InfoRow>

                          <InfoRow>
                            <strong>Data Alteração:</strong>
                            <span>{updt.instinc}</span>
                          </InfoRow>

                          <InfoRow>
                            <strong>Status:</strong>
                            <span>
                              {opAlteracaoPartnumber?.[status]?.label || '-'}
                            </span>
                          </InfoRow>
                        </UpdateInfo>

                        {status === 0 && (
                          <WrapperButtonsAction>
                            <ButtonAction
                              type="button"
                              onClick={() =>
                                handleActionButton(2, updt.partnumber)
                              }
                            >
                              Recusar
                            </ButtonAction>
                            <ButtonAction
                              type="button"
                              onClick={() =>
                                handleActionButton(1, updt.partnumber)
                              }
                              $isAprove
                            >
                              Aprovar
                            </ButtonAction>
                          </WrapperButtonsAction>
                        )}
                      </UpdateItem>
                    );
                  })
                ) : (
                  <EmptyList>
                    Este partnumber não possui atualizações.
                  </EmptyList>
                )}
              </UpdateList>

              {/* Upload imagem peça */}
              <ImagemUploadWrapper>
                <Title>Imagem da Peça</Title>
                <Span>
                  Envie uma foto da peça vinculando-a a um dos catálogos em que
                  este material aparece
                </Span>

                <ImagemUploadRow>
                  <select
                    value={idCatalogoImagem}
                    onChange={(e) => setIdCatalogoImagem(e.target.value)}
                  >
                    <option value="">Selecione o catálogo</option>
                    {paginaCatalogo.map((catalogo) => (
                      <option
                        key={catalogo.idCatalogo}
                        value={catalogo.idCatalogo}
                      >
                        {catalogo.nome || `Catálogo ${catalogo.idCatalogo}`}
                      </option>
                    ))}
                  </select>

                  <select
                    value={extensaoImagem}
                    onChange={(e) => setExtensaoImagem(e.target.value)}
                  >
                    <option value="jpeg">JPEG</option>
                    <option value="jpg">JPG</option>
                    <option value="png">PNG</option>
                    <option value="webp">WEBP</option>
                  </select>

                  <input
                    type="file"
                    accept="image/*"
                    onChange={handleSelecionarArquivoImagem}
                  />

                  <ImagemUploadButton
                    type="button"
                    onClick={handleEnviarImagem}
                    disabled={enviandoImagem}
                  >
                    {enviandoImagem ? 'Enviando...' : 'Enviar imagem'}
                  </ImagemUploadButton>
                </ImagemUploadRow>

                {arquivoImagem && (
                  <ImagemPreviewText>
                    Arquivo será salvo como: {id}-XXX.{extensaoImagem} (a
                    numeração final é definida automaticamente pelo sistema)
                  </ImagemPreviewText>
                )}
              </ImagemUploadWrapper>
            </LeftWrapper>

            {/* LADO DIREITO - LISTAGEM */}
            <RightWrapper>
              <RightContainer>
                <RightTitleContainer>
                  <div>
                    <Title>Lista de Catálogos do Partnumber</Title>
                    <Span>Catálogos vinculados a este material fabricante</Span>
                  </div>

                  <ContainerSpanAndButton $hasCatalogo={paginaCatalogo.length}>
                    <span>{paginaCatalogo.length}</span>

                    <button
                      type="button"
                      onClick={handleExportarCatalogos}
                      disabled={!paginaCatalogo.length}
                      title="Exportar listagem para Excel"
                    >
                      <MdOutlineFileDownload size={20} />
                    </button>
                  </ContainerSpanAndButton>
                </RightTitleContainer>

                {paginaCatalogo.length > 0 ? (
                  <WrapperList>
                    {paginaCatalogo.map((catalogo) => (
                      <ContainerList key={catalogo.idCatalogo}>
                        <HeaderContainerList>
                          <div>
                            <TitleModeloAndCatalogo>
                              {catalogo.modelos[0].descricao} /{' '}
                              {catalogo.nome || 'Catálogo sem nome'}
                            </TitleModeloAndCatalogo>

                            <PageInfo>
                              {catalogo.paginaCatalogo?.length || 0} página(s)
                              vinculada(s)
                            </PageInfo>
                          </div>

                          <ContainerCatalogoAndButton>
                            <span>ID Catálogo: {catalogo.idCatalogo}</span>

                            <button
                              type="button"
                              onClick={() =>
                                history.push('/catalogo/detalhe', {
                                  id: catalogo.idCatalogo,
                                })
                              }
                              title={`Ver detalhes do catálogo ${catalogo.idCatalogo}`}
                            >
                              Ver catálogo
                            </button>
                          </ContainerCatalogoAndButton>
                        </HeaderContainerList>

                        <WrapperLineList>
                          <ContainerLineList>
                            <BoxInfoHeader $minWidth120>Página</BoxInfoHeader>
                            <BoxInfoHeader $minWidth120>Item</BoxInfoHeader>
                            <BoxInfoHeader>Sistema</BoxInfoHeader>
                          </ContainerLineList>
                          {catalogo.paginaCatalogo?.length > 0 ? (
                            catalogo.paginaCatalogo.map((pagina) => (
                              <ContainerLineList
                                key={`${catalogo.idCatalogo}-${pagina.idPagina}-${pagina.itemPagina[0].idItem}`}
                              >
                                <BoxInfoLineList $minWidth120 $center>
                                  {pagina.idPagina}
                                </BoxInfoLineList>

                                <BoxInfoLineList $minWidth120 $center>
                                  {pagina.itemPagina[0].idItem}
                                </BoxInfoLineList>

                                <BoxInfoLineList>
                                  {pagina.descricao || '-'}
                                </BoxInfoLineList>
                              </ContainerLineList>
                            ))
                          ) : (
                            <CardEmptyList>
                              Este catálogo não possui páginas vinculadas.
                            </CardEmptyList>
                          )}
                        </WrapperLineList>
                      </ContainerList>
                    ))}
                  </WrapperList>
                ) : (
                  <CardEmptyList>
                    Nenhum catálogo vinculado a este partnumber.
                  </CardEmptyList>
                )}
              </RightContainer>
            </RightWrapper>
          </MasterWrapper>
        </Form>
      </FormWrapper>
    </>
  );
}

export { MaterialFabricanteEditar };
